import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const TeacherImportManualDialog = ({ isOpen, onClose }) => {
  const downloadSampleFile = () => {
    const templateUrl = "/templates/sample_teacher.csv";
    window.location.href = templateUrl;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle>How to Import Teachers</DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-6 overflow-y-auto flex-1">
          <div className="space-y-4">
            <p>Please follow these guidelines to ensure successful import:</p>

            <div className="bg-amber-50 border-l-4 border-amber-500 p-4 text-amber-700">
              <h3 className="font-bold">Required Format</h3>
              <p>Upload a CSV or Excel file with the following columns:</p>
            </div>

            <div className="overflow-x-auto">
              <Table className="w-full">
                <TableHeader>
                  <TableRow>
                    <TableHead className="w-1/4">Column Name</TableHead>
                    <TableHead className="w-1/4">Required</TableHead>
                    <TableHead className="w-2/4">Description</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody className="text-sm">
                  <TableRow>
                    <TableHead>firstName</TableHead>
                    <TableHead>Yes</TableHead>
                    <TableHead>Teacher&apos;s first name</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>middleName</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Teacher&apos;s middle name</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>lastName</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Teacher&apos;s last name</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>email</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Teacher&apos;s email (optional; must be valid if provided)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>phoneNumber</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>10 digits only; optional</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>employeeCode</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Unique employee code (auto-generated if blank)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>aadhaarCard</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Teacher&apos;s Aadhaar card number (optional)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>role</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Use &quot;teacher&quot; (or leave blank; inferred from other columns)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>subject</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Subject names matching your school, comma-separated (e.g. Mathematics or Science, English)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>qualification</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>e.g. B.Ed, M.Sc B.Ed</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>experience</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Years of experience (number)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>birthday</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Date of birth (dd/mm/yyyy or YYYY-MM-DD)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>bloodGroup</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>e.g. A+, B+ (no spaces)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>gender</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Male, Female, or Other</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>address_street</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Street address</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>address_city</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>City</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>address_state</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>State</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>address_pincode</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Postal/ZIP code (e.g. 400001)</TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead>address_country</TableHead>
                    <TableHead>No</TableHead>
                    <TableHead>Country (default: India)</TableHead>
                  </TableRow>
                </TableBody>
              </Table>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 text-blue-700">
              <h3 className="font-bold">Notes:</h3>
              <ul className="list-disc pl-5 space-y-1 mt-2">
                <li>
                  The system will automatically generate usernames and passwords (same as username).
                </li>
                <li>All teachers will be assigned to the current academic year.</li>
                <li>Existing teachers (same employee code) will be updated; only subjects are not updated on re-import.</li>
                <li>Subject names in the file must match subjects already created in your school.</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-2 px-6 py-4 border-t">
          <Button variant="outline" onClick={downloadSampleFile}>
            <Download className="h-4 w-4 mr-2" />
            Download Template
          </Button>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button
            onClick={() => {
              document.getElementById("file-upload").click();
              onClose();
            }}
          >
            Proceed to Import
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TeacherImportManualDialog;
